import { createEntityCollectionStore } from '@core/ngrx-legacy';

import type { ReferralsCondition } from '../types';
import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ReferralsCondition>()(EntityStoreKey.conditions);

export {
  actions as ConditionsActions,
  reducer as conditionsReducer,
  selectors as conditionsSelectors,
  namespace as ConditionsNamespace,
};
